var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80601 1.3375C6.29251 0.3445 7.70651 0.341 8.19751 1.3315L9.50501 3.9665L12.4305 4.393C13.5225 4.552 13.9595 5.893 13.171 6.665L11.0365 8.756L11.5365 11.624C11.7275 12.718 10.5755 13.552 9.59601 13.0295L6.99951 11.6455L4.40501 13.0285C3.42451 13.551 2.27201 12.7155 2.46451 11.621L2.96851 8.756L0.831511 6.667C0.0420109 5.895 0.479511 4.5525 1.57251 4.394L4.51801 3.967L5.80601 1.338V1.3375ZM8.31101 4.5595L7.00351 1.9245L5.71551 4.5535C5.62005 4.74826 5.47854 4.9168 5.30324 5.04452C5.12795 5.17225 4.92415 5.25531 4.70951 5.2865L1.76401 5.7135L3.90101 7.8025C4.21551 8.11 4.35851 8.5535 4.28201 8.987L3.77801 11.852L6.37251 10.469C6.56557 10.3661 6.78099 10.3123 6.99976 10.3123C7.21854 10.3123 7.43395 10.3661 7.62701 10.469L10.2235 11.853L9.72351 8.985C9.68634 8.77197 9.70156 8.5531 9.76785 8.34726C9.83414 8.14142 9.94951 7.9548 10.104 7.8035L12.2385 5.7125L9.31301 5.286C9.09968 5.25499 8.89707 5.17268 8.72254 5.04614C8.54802 4.9196 8.40681 4.75261 8.31101 4.5595Z",
    fill: "#8C8C8C",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.c38d63b55e106c0454818515036c0874.svg";
export { ForwardRef as ReactComponent };